import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import {
  Card,
  CardContent,
  Container,
  Typography,
  useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import GroupsIcon from "@mui/icons-material/Groups";
import { GET_QUESTIONNAIRE } from "../gql";
import { PREONBOARDING_ITEMS } from "../../Preonboarding/preonboardingData";
import LinkTileCard from "../../../../components/ui/LinkTileCard";
import LoadingCircle from "../../../../components/LoadingCircle";
import ErrorLayout from "../../../../components/layout/ErrorLayout";

const iconById: Record<string, JSX.Element> = {
  "okenko-o-seznamu": (
    <AutoStoriesIcon fontSize="medium" sx={{ color: "#CC0000" }} />
  ),
  "firemni-kultura": (
    <Diversity3Icon fontSize="medium" sx={{ color: "#CC0000" }} />
  ),
  "tvuj-tym-kontakty": (
    <GroupsIcon fontSize="medium" sx={{ color: "#CC0000" }} />
  ),
};

const fieldByItemId: Record<string, string> = {
  "okenko-o-seznamu": "preonboardingText",
  "firemni-kultura": "preonboardingText2",
  "tvuj-tym-kontakty": "preonboardingText3",
};

const QuestionnairePreonboarding = () => {
  const { id } = useParams<{ id: string }>();
  const theme = useTheme();

  const { data, loading, error } = useQuery(GET_QUESTIONNAIRE, {
    variables: { questionnaireId: id ? parseInt(id) : "" },
  });

  if (loading) return <LoadingCircle />;
  if (error) return <ErrorLayout errorMsg={error.message || ""} />;

  const questionnaire = data?.questionnaire;

  const visibleItems = PREONBOARDING_ITEMS.filter(
    (item) => questionnaire?.[fieldByItemId[item.id]],
  );

  return (
    <Container maxWidth="lg">
      <Grid container justifyContent="center">
        <Grid size={{ xs: 12, md: 8 }}>
          <Card>
            <CardContent sx={{ padding: theme.spacing(3) }}>
              <Typography variant="h2" mb={1}>
                Preonboarding
              </Typography>
              <Typography sx={{ color: "text.secondary" }} mb={3}>
                Přehled důležitých informací, které ti pomohou lépe se připravit
                před nástupem.
              </Typography>

              {visibleItems.length === 0 ? (
                <Typography sx={{ color: "text.secondary" }}>
                  Preonboardingový obsah pro tento dotazník zatím nebyl vyplněn.
                </Typography>
              ) : (
                <Grid container spacing={3}>
                  {visibleItems.map((item) => (
                    <Grid key={item.id} size={{ xs: 12 }}>
                      <LinkTileCard
                        to={`/dotazniky/${id}/preonboarding/${item.id}`}
                        icon={iconById[item.id]}
                        title={item.title}
                        subtitle={item.subtitle}
                      />
                    </Grid>
                  ))}
                </Grid>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default QuestionnairePreonboarding;
